import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton,AppBar,Toolbar } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';

import $ from "jquery";
import Scrollbar from "perfect-scrollbar-react";
import classNames from "classnames";
import "perfect-scrollbar-react/dist/style.min.css";
import "react-table/react-table.css";
import Select from 'react-select';
import Loader from "other-components/loader/loader";
import Tooltip from 'material-ui/Tooltip';
import { withAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert'; // Import
import printjs from 'print-js';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';

const CustomTbodyComponent = props => (
    <div {...props} className={classNames("rt-tbody", props.className || [])}>
        <Scrollbar>{props.children}</Scrollbar>
    </div>
);


const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    smaller: {
        width: 30,
        height: 20,
    }
});

var selecterBrokerType = 0;
var selecterBrokerTypeName = 0;
var startDate = '';
var endDate ='';
var endDate = '';
var selectCheackBox = 0;



class LedgerReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            open: false,
            selecterBrokerType: 0,
            selecterBrokerTypeName: 0,
            startDate: moment(new Date()).format("YYYY-MM-DD"),
            endDate: moment(new Date()).format("YYYY-MM-DD"),
            selectCheackBox: 0,
            tableData: [],
            ledgerType: '',
            ledgers: [],
            totalDebit:0,
            totalcredit:0
        };
        this.handleChangeLedgerType = this.handleChangeLedgerType.bind(this);
        this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
        this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
        this.handleChangecheackBox = this.handleChangecheackBox.bind(this);
        this.loadLedgers();

    }

    state = {
        value: 0,
        contactDetail:false,
        customerDetail:false,

    };



   
     loadLedgers() {
        var ledgers = [];
        // axios.get('http://localhost:5009/ledgerAccount/getLedgerAccountDetails')
        axios.get(window.accountServer + '/ledgerAccount/getLedgerAccountDetails')
            .then(response => {

                for (let i = 0; i < response.data.ledgerAccountDetails.length; i++) {
                    // console.log("rrrr" + JSON.stringify(response.data[i].bank_name));
                    ledgers.push({
                        value: response.data.ledgerAccountDetails[i].ID_LEDGER_ACCOUNT,
                        label: response.data.ledgerAccountDetails[i].NAME
                    });
                }
                this.setState({ ledgers: ledgers });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

   

    handleChangeLedgerType = (selectedOption) => {
        this.setState({
            ledgerType: selectedOption
        });

    }

    handleChangeStartDate(event) {
        //alert(event.target.value)
        startDate = event.target.value;
        this.setState({ startDate: event.target.value });

    }

    handleChangeEndDate(event) {
        //alert(event.target.value)
        endDate = event.target.value;
        this.setState({ endDate: event.target.value });

    }

    handleChangecheackBox = name => event => {

        this.setState({ [name]: event.target.checked });
        selectCheackBox = event.target.checked;
    };

    handleClickView = () => {
        
        const ledgerObj = {
            ledger_id: this.state.ledgerType.value,
            fromDate: this.state.startDate,
            toDate: this.state.endDate
        }

        var ledger_id = this.state.ledgerType.value;
        var fromDate = this.state.startDate;
        var toDate = this.state.endDate;

        var strtDt = new Date(fromDate);
        var endDt = new Date(toDate);

        if (ledger_id != null && ledger_id!= "") {
            if (fromDate != null && fromDate != "") {
                if (toDate != null && toDate != "") {
                    if (endDt.getTime() < strtDt.getTime()) {
                        this.props.alert.error("to date Can't be less than from date");
                    } else {
                        this.setState({ loading: true });
                        // axios.post('http://localhost:5009/transactionLedger/getLedgerreportData',ledgerObj )
                        axios.post(window.accountServer + '/transactionLedger/getLedgerreportData', ledgerObj)
                            .then(response => {
                               var resObj = response.data.ledgerReport;
                               this.setState({ 
                                
                                totalDebit:0,
                                totalcredit:0
                            });
                                this.appendToTable(resObj)
                
                            }
                        )
                        .catch(error => {
                            // logger.error(error);
                        }); 
                    }                   

    } else {
        this.props.alert.error("Select To Date");
    }
} else {
    this.props.alert.error("Select From Date.");
}
} else {
this.props.alert.error("Select Ledger Account");
}
    };

    appendToTable(ledgerObj) {
        var totalDebit = this.state.totalDebit;
        var totalcredit = this.state.totalcredit;
        console.log(ledgerObj)
        var data = [];
        // var active;



        
        for (var i = 0; i < ledgerObj.length; i++) {
            // if (accCategoryObj[i].IS_ACTIVE == 1) {
            //     active = 'Active'
            // } else {
            //     active = 'Inactive'

            // }
            totalDebit = totalDebit + parseFloat(ledgerObj[i].DR) 
            totalcredit = totalcredit + parseFloat(ledgerObj[i].CR)
            data.push({
                id: ledgerObj[i].ID_TRANSACTION_LEDGER_DETAIL,
                date: (ledgerObj[i].CREATED_DATE).substring(0, 10),
                transaction_no: ledgerObj[i].ID_TRANSACTION_LEDGER_HEADER,
                description: ledgerObj[i].oposite_ledger,
                debit: ledgerObj[i].DR,
                credit: ledgerObj[i].CR,
                is_active: ledgerObj[i].IS_ACTIVE,
                // active: active
            });


        }

        this.setState({ 
            tableData: data ,
            totalDebit:totalDebit,
            totalcredit:totalcredit
        });
        this.setState({ loading: false });
    }

    handleClickPrint = () => {

        
        // var ctype = selecterBrokerType;
        // var cstartdate = startDate;
        // var cenddate = endDate;
        // var all = selectCheackBox;

        var ledger_id = this.state.ledgerType.value;
        var ledger_name = this.state.ledgerType.label;
        var fromDate = this.state.startDate;
        var toDate = this.state.endDate;




        if (ledger_id != null && ledger_id!= "") {
            if (fromDate != null && fromDate != "") {
                if (toDate != null && toDate != "") {

                   
                        var address = null;
                        axios.get(window.reportServer + '/ledgerReport/get/ledgerReport', {
                        // axios.get('http://localhost:5008/ledgerReport/get/ledgerReport', {
                            params: {
                                fromDate: fromDate,
                                toDate: toDate,
                                ledger_id: ledger_id,
                                ledger_name:ledger_name
                            }
                        })
                            .then(response => {
            
                                address = response.data.path;
                                address = window.reportServer+"/" + address;
                                
                                //alert(address)
                                printjs({ printable: address, type: 'pdf', showModal: true })
            
                            }
                            );
                    
                        
            
                    } else {
                        this.props.alert.error("Select To Date");
                    }
                } else {
                    this.props.alert.error("Select From Date.");
                }
            } else {
                this.props.alert.error("Select Ledger Account");
            }
        

        };

        handleClickTableContactPersonClose = (rowInfo) => {
            this.setState({ contactDetail: false })
        }

        handleClickTableCustomerDetailClose = () => {
            this.setState({ customerDetail: false })
        }

        

        render() {
            if (this.state.loading) {
                return (
                    <Loader />
                );
            } else {
                const { openEditContactDialog } = this.props;
                const { canSubmit } = this.state;
                const { classes } = this.props;
                return (
                    <FusePageSimple
                        classes={{
                            root: classes.layoutRoot,
                            toolbar: classes.layoutToolbar
                        }}

                        contentToolbar={
                            <div className="flex flex-1 flex-col sm:flex-row items-center justify-between p-24">

                                <div className="flex flex-1 items-center">

                                    <div className="subtitle-color flex items-center">
                                        <Icon className="text-32 mr-12">account_box</Icon>
                                        <Typography class="subtitle-color" variant="title">Ledger Report</Typography>
                                    </div>


                                </div>


                            </ div>


                        }
                        content={

                            <div class="flex h-auto ">

                                <div class="w-full bg-white h-auto m-4">

                                    <div class="border-1 w-full p-4 ">


                                        <div className="sm:p-16 border-0 inline-block sm:w-1/5"  >
                                            {/* <h3 className="h2 pb-8">Ledger Account</h3> */}

                                            Ledger Account :
                                             <Select
                                                className="w-full mt-16"
                                                name="selectledger"
                                                // label="Broker Type"
                                                //value="none"
                                                value={this.state.ledgerType}
                                                onChange={this.handleChangeLedgerType}
                                                options={this.state.ledgers}
                                            />
                                                {/* <MenuItem value={0}>
                                                    <em> select ledger</em>
                                                </MenuItem>
                                                {this.state.brokerType.map(function (item, i) {
                                                    return <MenuItem value={item.brokerTypeId}>{item.brokerTypeName}</MenuItem>;
                                                })} */}

                                            {/* </Select> */}



                                            {/* <Checkbox
                                                checked={this.state.selectCheackBox}
                                                onChange={this.handleChangecheackBox('selectCheackBox')}

                                            /> */}
                                            {/* All */}
                                    </div>


                                        <div className=" block p-20" >
                                            {/* <h3 className="h2 pb-4">Net Calebration</h3> */}

                                            <div className=" border-0 inline-block sm:w-1/2" >

                                                From Date :
    
                                            <TextField
                                                    className="pl-16 mx-10"
                                                    type="date"
                                                    name="unitNo"
                                                    //label="No of Unit"
                                                    value={this.state.startDate}
                                                    onChange={this.handleChangeStartDate}
                                                    validations={{
                                                        minLength: 1
                                                    }}
                                                    validationErrors={{
                                                        minLength: 'Min character length is 4'
                                                    }}
                                                    required
                                                //disabled={true}
                                                />

                                            </div>



                                            <div className="border-0 inline-block sm:w-1/2" >

                                                To Date
    
                                            <TextField
                                                    className="pl-16 mx-10"
                                                    type="date"
                                                    name="unitNo"
                                                    //label="No of Unit"
                                                    value={this.state.endDate}
                                                    onChange={this.handleChangeEndDate}
                                                    validations={{
                                                        minLength: 1
                                                    }}
                                                    validationErrors={{
                                                        minLength: 'Min character length is 4'
                                                    }}
                                                    required
                                                //disabled={true}
                                                />

                                            </div>
                                        </div>

                                        <div className="sm:pb-8 w-full">
                                            <div className="border-0 sm:inline-block sm:w-3/4" >
                                            </div>
                                            <DialogActions className="justify-right pl-16">
                                                <Tooltip
                                                    enterDelay={300}
                                                    id="tooltip-controlled"
                                                    leaveDelay={300}
                                                    placement="bottom"
                                                    title="Do you want to View ?"
                                                >
                                                    <Button
                                                        onClick={this.handleClickView}
                                                        type="submit"
                                                        variant="raised"
                                                        color="secondary"
                                                        className="px-40 mx-16"
                                                        aria-label="Help"
                                                    //disabled={!canSubmit}
                                                    >
                                                        View
                                                             </Button>
                                                </Tooltip>

                                                <Tooltip
                                                    enterDelay={300}
                                                    id="tooltip-controlled"
                                                    leaveDelay={300}
                                                    placement="bottom"
                                                    title="Do you want to Print ?"
                                                >
                                                    <Button
                                                       onClick={this.handleClickPrint}
                                                        type="submit"
                                                        variant="raised"
                                                        color="secondary"
                                                        className="px-40 mx-16"
                                                        aria-label="Help"
                                                    //disabled={!canSubmit}
                                                    >
                                                        Print
                                    </Button>
                                                </Tooltip>
                                            </DialogActions>
                                        </div>

                                    </div>

                                   {/* //////////////////////////////////////**************** */}
                                
                                   <div>Date Range : {this.state.startDate} - {this.state.endDate}</div>
                                    <div class="border-0 m-4">

                                    
                                        <ReactTable


                                            getTrProps={(state, rowInfo, column) => {
                                                return {
                                                    className: "cursor-pointer",
                                                    // onClick: (e, handleOriginal) => {
                                                       
                                                    
                                                    //         this.handleClickTable(rowInfo.original,column.field);
                                                        
                                                    // }
                                                    
                                                }
                                            }}
                                            TbodyComponent={CustomTbodyComponent}
                                            data={this.state.tableData}

                                            columns={[

                                                {
                                                    Header: "Date",
                                                    accessor: "date",
                                                    width:300

                                                },
                                                {
                                                    Header: "Transaction No",
                                                    accessor: "transaction_no",
                                                    width:200

                                                }
                                                ,
                                                {
                                                    Header: "Description",
                                                    accessor: "description",

                                                }
                                                ,
                                                // {
                                                //     Header: "Amount",
                                                //     accessor: "amount",
                                                   
                                                // }
                                                // ,
                                                {
                                                    Header: "Debit",
                                                    accessor: "debit",
                                                    Footer: (
                                                        <strong>{this.state.totalDebit}</strong>
                                                      )
                                                 
                                                },
                                                {
                                                    Header: "Credit",
                                                    accessor: "credit",
                                                    Footer: (
                                                        <strong>{this.state.totalcredit}</strong>
                                                        
                                                      )
                                                }
                                                // ,
                                                // {
                                                //     Header: "Balance",
                                                //     accessor: "balance",
                                                //     Footer: (
                                                //         <strong></strong>
                                                //       )
                                                // }

                                            ]}
                                            defaultPageSize={10}
                                            style={{
                                                height: "450px" // This will force the table body to overflow and scroll, since there is not enough room
                                            }}
                                            className="-striped -highlight"
                                        />
                                    </div>
                                {/* <div className="float-right">

                                    <TextField
                                        className="w-full md:w-1/3 pr-24 "
                                        type="number"
                                        // name="telephone"
                                        // label="Telephone"
                                        value='200.00'
                                       disabled
                                    />


                                    <TextField
                                        className="w-full md:w-1/3 pr-24"
                                        type="number"
                                        // name="fax"
                                        // label="Fax"
                                        value='200.00'
                                        disabled
                                    />
                                    <TextField
                                        className="w-full md:w-1/3 pr-24 "
                                        type="text"
                                        // name="acc_holder_name"
                                        // label="Account Holder's Name"
                                        value='200.00'
                                        disabled
                                    />
                                    </div> */}
                                </div>



                            </div>
                        }
                    />
                )

                
            }
          
        }

        componentWillMount() {
            var brokerType = [];
            // get customer type
            axios.get(window.salesServer+'/broker/getBrokersList')
                .then(response => {
                      console.log(response.data.length);

                    var c;
                    for (c = 0; c < response.data.brokers.length; c++) {
                        brokerType.push({
                            brokerTypeId: JSON.stringify(response.data.brokers[c].ID_SALES_BROKER),
                            brokerTypeName: response.data.brokers[c].NAME,
                        });


                    }

                    this.setState({ brokerType: brokerType });

                }
                );
            this.setState({ loading: false });
        }

    }

    export default withStyles(styles, { withTheme: true })(withAlert(LedgerReport));










// WEBPACK FOOTER //
// ./src/main/content/accountingReports/ledgerReport/LedgerReport.js